import {
	LinearProgress,
	linearProgressClasses,
	Typography,
} from '@mui/material'
import styles from '../index.module.scss'
import Modal from '../Modal/Modal'
import { useState } from 'react'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setSettingsTab } from '../../../features/authSlice'
import { clearSurveyData } from '../../../features/kazooEventSlice'

const Progress = ({ step }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [activeModal, setActiveModal] = useState(false)
	const businessTypes = useSelector((s) => s.auth.user?.businessTypes)
	const closeAllModals = () => {
		setActiveModal(false)
		dispatch(clearSurveyData())
	}
	return (
		<div className={styles.progressMain}>
            {/* commented out for launch */}
			{/* <Typography variant="h6" className={styles.completeProfileTitle}>
				On Time Magic Timeline Tool - Finish Survey
			</Typography>
			<LinearProgress
				variant="determinate"
				value={(step - 1) * 25}
				sx={{
					padding: '0.5rem',
					borderRadius: '1rem',
					backgroundColor: '#DFE4EB',
					[`& .${linearProgressClasses.bar}`]: {
						backgroundColor: '#7CA6BD',
						borderRadius: '50px',
					},
				}}
			/>
			<div className={styles.getStartRow}>
				<Typography variant="h6">
					Progress: {Math.max(step - 1, 0) * 25}%
				</Typography>
				<ButtonCustom
					variant="default"
					onClick={() => {
						if (!businessTypes) {
							dispatch(setSettingsTab(4)) // redirect to business profile
							navigate('/settings')
						} else {
							setActiveModal(true)
						}
					}}
				>
					{step === 1 ? 'Start Survey' : 'Continue'}
					<img src="/images/arrow_back.svg" alt="arrow" />
				</ButtonCustom>
			</div>
			{activeModal && businessTypes && (
				<Modal
					activeModal={activeModal}
					closeAllModals={closeAllModals}
				/>
			)} */}
		</div>
	)
}

export default Progress
